import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
        
        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Child Story Time. We respect your privacy and are committed to protecting your personal data.
            This privacy policy will inform you about how we look after your personal data when you visit our website
            and tell you about your privacy rights and how the law protects you.
          </p>
        </section>
        
        <section>
          <h2>2. The Data We Collect</h2>
          <p>
            We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
          </p>
          <ul>
            <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
            <li><strong>Contact Data</strong> includes email address.</li>
            <li><strong>Technical Data</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
            <li><strong>Usage Data</strong> includes information about how you use our website and services.</li>
          </ul>
        </section>
        
        <section>
          <h2>3. How We Use Your Data</h2>
          <p>
            We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
          </p>
          <ul>
            <li>To register you as a new customer.</li>
            <li>To provide and manage your account.</li>
            <li>To provide our services to you.</li>
            <li>To manage our relationship with you.</li>
            <li>To improve our website, products/services, marketing, and customer relationships.</li>
            <li>To recommend content that may be of interest to you.</li>
            <li>To comply with legal obligations.</li>
          </ul>
        </section>
        
        <section>
          <h2>4. Data Security</h2>
          <p>
            We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used,
            or accessed in an unauthorized way, altered, or disclosed. We limit access to your personal data to those employees,
            agents, contractors, and other third parties who have a business need to know.
          </p>
        </section>
        
        <section>
          <h2>5. Data Retention</h2>
          <p>
            We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for,
            including for the purposes of satisfying any legal, accounting, or reporting requirements.
          </p>
        </section>
        
        <section>
          <h2>6. Your Legal Rights</h2>
          <p>
            Under certain circumstances, you have rights under data protection laws in relation to your personal data including:
          </p>
          <ul>
            <li>The right to request access to your personal data.</li>
            <li>The right to request correction of your personal data.</li>
            <li>The right to request erasure of your personal data.</li>
            <li>The right to object to processing of your personal data.</li>
            <li>The right to request restriction of processing your personal data.</li>
            <li>The right to request transfer of your personal data.</li>
            <li>The right to withdraw consent.</li>
          </ul>
        </section>
        
        <section>
          <h2>7. Contact Us</h2>
          <p>
            If you have any questions about this privacy policy or our privacy practices, please contact us at:
            <br />
            <a href="mailto:privacy@childstorytime.com">privacy@childstorytime.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy; 